import React from 'react';

import TagValueViewer from 'metadata/TagValueViewer';
import SortableTable from 'ui-library/SortableTable';
import fuzzydate from 'util/fuzzydate';

import {LookupFieldResult} from './LookupFieldDefinitionConstants';

interface LookupFieldValuesStaticTableProps {
  fieldName: string;
  results: Array<LookupFieldResult>;
  isDataTable: boolean;
}

/**
 * Table that displays lookup field results
 */
export default function LookupFieldValuesStaticTable(
  props: LookupFieldValuesStaticTableProps
): JSX.Element | null {
  const columns = [SortableTable.defaultColumn(props.fieldName, 'fieldName', {sortable: false})];
  if (props.isDataTable) {
    columns.push(
      SortableTable.defaultColumn('Created at', 'created', {sortable: false}),
      SortableTable.defaultColumn('Entry', 'entry', {sortable: false})
    );
  }

  const rows = props.results.map((result: LookupFieldResult, index: number) => ({
    fieldName: result.tagValue ? <TagValueViewer tag={result.tagValue} /> : result.value,
    created: result.assayResultSummary ? fuzzydate(result.assayResultSummary.createdAt) : 'N/A',
    id: index,
    entry: result.entry ? result.entry.name : 'N/A',
  }));

  return (
    <div className="lookupFieldValuesTable">
      <SortableTable columns={columns} rows={rows} emptyTableText="No values" />
    </div>
  );
}
